import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { loadProviderPanel } from "../../apis";

const ProviderPanelContext = React.createContext();

const ProviderPanelProvider = ({ providerId, practiceTeamParticipantId, specialty, ...props }) => {
  const [{ provider, practiceTeamParticipant }, setProviderPanel] = useState({});

  useEffect(() => {
    (async () => {
      const providerPanel = await loadProviderPanel({
        providerId: parseInt(providerId),
        practiceTeamParticipantId: parseInt(practiceTeamParticipantId),
      });

      setProviderPanel(providerPanel);
    })();
  }, []);

  if (!provider) {
    return null;
  }

  return (
    <ProviderPanelContext.Provider
      {...props}
      value={{
        provider,
        practiceTeamParticipant: practiceTeamParticipant && ({
          ...practiceTeamParticipant,
        }),
        isPrincipal: practiceTeamParticipant ? practiceTeamParticipant.principalFlg : !provider.practiceTeamParticipants.length,
        specialty
      }}
    />
  );
};

ProviderPanelProvider.propTypes = {
  providerId: PropTypes.string.isRequired,
  practiceTeamParticipantId: PropTypes.number,
  children: PropTypes.node.isRequired,
};

export const useProviderPanel = () => {
  const context = useContext(ProviderPanelContext);

  if (context === undefined) {
    throw new Error("useProviderPanel must be used within a ProviderPanelProvider");
  }

  return context;
};

export default ProviderPanelProvider;
